import { FormProvider, useForm } from 'react-hook-form';
import { useAppContext } from 'src/contexts/AppContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { getInHandDateBasedOnEvent } from 'src/utils/eventWithDataUtils';
import { DeliveryType, Feature } from 'src/WebApiController';

import {
  SeatSaverListingDetailsInputForm,
  SeatSaverListingWizardProps,
} from './SeatSaverListingWizard.types';
import { SeatSaverListingWizardBody } from './SeatSaverListingWizardBody';

export const SeatSaverListingWizard = ({
  cancelTo,
  events,
  ...rest
}: SeatSaverListingWizardProps) => {
  const { loginContext } = useAppContext();
  const ihdTimezoneFix = useUserHasFeature(Feature.IhdTimezoneFix);

  const defaultDaysBeforeEvent =
    loginContext?.user?.activeAccount?.sellerAccountSettings
      ?.placeholderInHandDaysBeforeEvent ?? 1;

  const methods = useForm<SeatSaverListingDetailsInputForm>({
    defaultValues: {
      inputs:
        events?.map((ev) => ({
          event: ev,
          autoBroadcastCreatedListing: false,
          seatings: [],
          quantity: 0,
          unitNetProceeds: 0,
          websitePrice: 0,
          faceValue: null,
          deliveryType: DeliveryType.InApp,
          inHandDate: getInHandDateBasedOnEvent(
            ev,
            defaultDaysBeforeEvent,
            ihdTimezoneFix
          ),
          daysBeforeEvent: defaultDaysBeforeEvent,
          sellerOwnTickets: true,
        })) ?? [],
    },
  });

  return (
    <FormProvider {...methods}>
      <SeatSaverListingWizardBody
        {...methods}
        events={events}
        cancelTo={cancelTo}
        {...rest}
      />
    </FormProvider>
  );
};
